import { scrollDirectionSelectors } from '@pm2/react-utils';
import { forcedHeaderStateSelectors } from '@utils/react/selectors';

/**
 * The selector to determine whether or not the header is collapsed has grown
 * fairly complex over time. Hence we export this single selector which is
 * authorative in regards to if the header is collapsed.
 */
const headerCollapsedSelector = ({
  prefix = "html",
  postfix = "&"
} = {}) => `${prefix}${scrollDirectionSelectors.scrollingDown()}:not(${scrollDirectionSelectors.atTopOfPage()}):not(${forcedHeaderStateSelectors.expanded()}) ${postfix ?? ""}, ${prefix}${forcedHeaderStateSelectors.collapsed()}:not(${scrollDirectionSelectors.atTopOfPage()}) ${postfix ?? ""}`;

/**
 * ... the same goes for the expanded selector
 */
const headerExpandedSelector = ({
  prefix = "html",
  postfix = "&"
} = {}) => `${prefix}.${scrollDirectionSelectors.scrollingUp()}:not(${forcedHeaderStateSelectors.collapsed()}) ${postfix ?? ""}, ${prefix}${forcedHeaderStateSelectors.expanded()} ${postfix ?? ""}`;
const headerCls = "_61h1j0gljx";
const wrapperCls = "_61w1j0gvlq";
const containerCls = "_61c19dnki4";
const topsection = "_61trxqmpc";
const navCls = "_61n7v68gl";

export { containerCls, headerCls, headerCollapsedSelector, headerExpandedSelector, navCls, topsection, wrapperCls };
import "./Header.style.linaria.module.css";
//# sourceMappingURL=Header.style.js.map
